import { Cell, Grid, Tooltip } from 'bold-ui'
import { useAcessoLotacao } from 'components/auth/useAcessoLotacao'
import { isUnidadeSaudeCEO } from 'components/auth/useSessionUtils'
import { EquipeSelectField } from 'components/form'
import { resolveValue } from 'components/form/final-form/useField'
import { CEO_ENABLED } from 'config/flags'
import { UnidadeSaude } from 'graphql/types.generated'
import React from 'react'
import { useFormState } from 'react-final-form'
import { MetaPath } from 'util/metaPath'
import { NovoAtendimentoFormModel } from 'view/atendimentos/model'
import { resolveEquipeTooltip, resolveProfissionalTooltip } from 'view/atendimentos/tooltipResolver'
import { AgendamentoDia } from 'view/atendimentos/types/AgendamentoDia'
import { TipoServicoCheckField } from 'view/configuracoes/municipal/tipo-servico/TipoServicoCheckField'
import { LotacaoSelectField } from 'view/profissional/lotacao/LotacaoSelectField'

import { AgendamentosDiaField } from '../../../../agenda/AgendamentosDiaField'

export interface NovoAtendimentoFormProps {
  agendamentosDia?: AgendamentoDia[]
  name: MetaPath<NovoAtendimentoFormModel>
  novoAtendimentoAgendado: any
}

export function NovoAtendimentoForm(props: NovoAtendimentoFormProps) {
  const { name, agendamentosDia, novoAtendimentoAgendado } = props
  const { unidadeSaude } = useAcessoLotacao()

  const { values: formValues } = useFormState({ subscription: { values: true } })
  const values = resolveValue(formValues, name)
  const isCEO = isUnidadeSaudeCEO(unidadeSaude as UnidadeSaude) && !!CEO_ENABLED

  return (
    <>
      <Cell size={5}>
        <AgendamentosDiaField
          name={name.agendados}
          novoAtendimentoAgendadoName={novoAtendimentoAgendado}
          agendamentosDia={agendamentosDia}
        />
      </Cell>
      <Cell size={12}>
        <Grid>
          <Cell size={isCEO ? 12 : 6}>
            <Tooltip text={resolveProfissionalTooltip(values)}>
              <LotacaoSelectField
                name={name.lotacao}
                label='Profissional'
                unidadeSaudeId={unidadeSaude.id}
                disabled={(values?.equipe && !values?.lotacao) || !!values?.agendados?.length}
                loadItemsOnOpen={false}
              />
            </Tooltip>
          </Cell>
          {!isCEO && (
            <Cell size={6}>
              <Tooltip text={resolveEquipeTooltip(values)}>
                <EquipeSelectField
                  name={name.equipe}
                  label='Equipe'
                  unidadeSaudeId={unidadeSaude.id}
                  disabled={!!values?.lotacao || !!values?.agendados?.length}
                />
              </Tooltip>
            </Cell>
          )}
        </Grid>
      </Cell>
      <Cell size={12}>
        <div>
          <TipoServicoCheckField name={name.tiposServico} />
        </div>
      </Cell>
    </>
  )
}
